export default __webpack_public_path__ + "static/media/play.f303159b.svg";